import React from 'react';
import Button from 'components/button/ActionButton';
import PropTypes from 'prop-types';
import translate from 'components/hoc/translate';
import { colors } from 'theme/theme';
import { FileDownloadIcon } from 'assets/materialIcons/materialIcons';

const ExportButton = (props) => {
    const { translate, onClick } = props;

    return (
        <Button
            icon={ <FileDownloadIcon color={ colors.doveGray } /> }
            title={ translate('actions.export') }
            onClick={ onClick }
            style={ { color: colors.doveGray } }
        />
    );
};

ExportButton.propTypes = {
    onClick: PropTypes.func,
    translate: PropTypes.func.isRequired,
};

export default translate(ExportButton);


// WEBPACK FOOTER //
// ./src/components/button/actions/ExportButton.js